import React, { useState, useEffect } from 'react';
import Logo from "../images/Infomanav.svg";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactComponent as PasswordShow } from "../images/icon-eye.svg";
import { ReactComponent as PasswordHide } from "../images/icon-eye-hide.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import FivePaisaLogo from "../images/5PaisaLogo.svg";
import GrowwLogo from "../images/growwLogo.svg";
import AngelOneLogo from "../images/Angel_One_Logo.png";
 
import "../css/style_SignUp.css"
import IconCheckError from "../images/IconCheckError.svg";
import { FaRegQuestionCircle } from "react-icons/fa";
import {
  Mail,
  Key,
  User,
  Lock,
  Shield,
  Hash,
  CreditCard,
  Smartphone,
  ChevronRight,
  ChevronLeft,
  Check,
  Tag
} from 'lucide-react';

const generateGrowwBrokerUserId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `grw_${crypto.randomUUID().replace(/-/g, '')}`;
  }
  return `grw_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
};

const PremiumHelpModal = ({ id, labelId, title, subtitle, children, note }) => (
  <div className="modal fade signup-wizard-help-modal" id={id} aria-labelledby={labelId} aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
      <div
        className="modal-content shadow-lg border-0"
        style={{
          maxHeight: "700px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          backgroundColor: "#F4F6F9"
        }}
      >
        <div
          className="modal-header border-0"
          style={{
            position: "sticky",
            top: "0",
            backgroundColor: "white",
            zIndex: 10,
            borderRadius: "12px 12px 0 0",
            padding: "24px 32px 16px 32px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
          }}
        >
          <div style={{ width: "100%" }}>
            <h5
              className="modal-title mb-0"
              id={labelId}
              style={{
                color: "#003092",
                fontSize: "24px",
                fontWeight: "600",
                letterSpacing: "-0.5px"
              }}
            >
              {title}
            </h5>
            <div
              style={{
                width: "80px",
                height: "4px",
                backgroundColor: "#FFAB5B",
                marginTop: "12px",
                borderRadius: "2px"
              }}
            ></div>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            style={{ marginTop: "-8px" }}
          ></button>
        </div>

        <div
          className="modal-body"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "32px",
            backgroundColor: "white",
            margin: "10px 16px 16px 16px",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
          }}
        >
          <h2
            style={{
              color: "#003092",
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "20px"
            }}
          >
            {title}
          </h2>

          {subtitle && (
            <h5
              className="fw-semibold mb-4"
              style={{
                color: "#003092",
                fontSize: "16px"
              }}
            >
              {subtitle}
            </h5>
          )}

          <div
            className="p-3"
            style={{
              backgroundColor: "#F4F6F9",
              borderRadius: "8px",
              borderLeft: "4px solid #FFAB5B"
            }}
          >
            {children}
          </div>

          {note && (
            <p
              className="mb-0 mt-4 p-3"
              style={{
                backgroundColor: "#FFF7ED",
                borderRadius: "8px",
                color: "#5A5A5A",
                lineHeight: "1.6",
                borderLeft: "4px solid #FFAB5B"
              }}
            >
              {note}
            </p>
          )}
        </div>

        <div
          className="modal-footer border-0"
          style={{
            position: "sticky",
            bottom: "0",
            backgroundColor: "white",
            zIndex: 10,
            borderRadius: "0 0 12px 12px",
            padding: "16px 32px 24px 32px",
            boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
          }}
        >
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-bs-dismiss="modal"
            style={{
              borderColor: "#003092",
              color: "#003092",
              padding: "10px 28px",
              borderRadius: "8px",
              fontWeight: "500",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#003092";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#003092";
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
);

const SignupWizard = ({ setProgress }) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const pmsApiBaseUrl = process.env.REACT_APP_PMS_API_BASE_URL || "https://pmsapi.infomanav.in";
  const [tabName, setTabName] = useState('Signup');
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);

  useEffect(() => {
    document.title = tabName;
    // setProgress(100)
  }, [tabName]);

  // Form state
  const [formData, setFormData] = useState({
    selectedBroker: '5Paisa',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    accountName: '',
    userKey: '',
    userId: '',
    pin: '',
    encryptionKey: '',
    clientCode: '',
    totpKey: '',
    growwApiKey: '',
    growwApiSecret: '',
    growwTotpToken: '',
    growwTotpQrToken: '',
    angelClientCode: '',
    angelPin: '',
    angelTotpKey: '',
    angelApiKey: '',
    angelSecretKey: ''
  });

  const getEmptyFormData = (selectedBroker = '5Paisa') => ({
    selectedBroker,
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    accountName: '',
    userKey: '',
    userId: '',
    pin: '',
    encryptionKey: '',
    clientCode: '',
    totpKey: '',
    growwApiKey: '',
    growwApiSecret: '',
    growwTotpToken: '',
    growwTotpQrToken: '',
    angelClientCode: '',
    angelPin: '',
    angelTotpKey: '',
    angelApiKey: '',
    angelSecretKey: ''
  });

  // Console log whenever formData changes
  useEffect(() => {
    console.log('FormData Updated:', formData);
  }, [formData]);


  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [messageType, setMessageType] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [passwordStrength, setPasswordStrength] = useState({ strength: 0, message: '' });




  const navigate = useNavigate();

  // Common toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  };

  // Success toast function
  const showSuccessToast = (message) => {
    toast.success(message, {
      ...toastOptions,
      icon: "✅",
    });
  };

  // Error toast function
  const showErrorToast = (message) => {
    toast.error(message, {
      ...toastOptions,
      icon: "⚠️",
    });
  };

  // Warning toast function
  const showWarningToast = (message) => {
    toast.warn(message, {
      ...toastOptions,
      icon: "⚠️",
    });
  };




  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Real-time password strength check
    if (name === 'password') {
      const strength = checkPasswordStrength(value);
      setPasswordStrength(strength);
    }

    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleBrokerTabChange = (brokerName) => {
    setFormData((prev) => ({ ...prev, selectedBroker: brokerName }));

    // If user switches from 5Paisa to Groww while on step 3, move back to step 2
    if (brokerName === 'Groww' && currentStep > 2) {
      setCurrentStep(2);
      setCompletedSteps((prev) => prev.filter((stepNo) => stepNo <= 2));
    }
  };



  const checkPasswordStrength = (password) => {
    let strength = 0;
    let feedback = [];

    if (password.length >= 8) strength += 1;
    else feedback.push('at least 8 characters');

    if (/[a-z]/.test(password)) strength += 1;
    else feedback.push('lowercase letter');

    if (/[A-Z]/.test(password)) strength += 1;
    else feedback.push('uppercase letter');

    if (/\d/.test(password)) strength += 1;
    else feedback.push('number');

    if (/[@$!%*?&#]/.test(password)) strength += 1;
    else feedback.push('special character');

    const strengthLevels = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];

    return {
      strength: strength,
      message: strengthLevels[strength - 1] || 'Very Weak',
      missing: feedback
    };
  };


  const validateAccountName = (errors) => {
    const accountName = formData.accountName.trim();
    if (!accountName) {
      errors.accountName = 'Account name is required';
    } else if (accountName.length < 3) {
      errors.accountName = 'Account name must be at least 3 characters';
    } else if (accountName.length > 40) {
      errors.accountName = 'Account name must be at most 40 characters';
    } else if (!/^[a-zA-Z0-9][a-zA-Z0-9 _-]*$/.test(accountName)) {
      errors.accountName =
        'Use letters, numbers, spaces, hyphens or underscores';
    }
  };

  const validateStep = (step) => {
    const errors = {};

    switch (step) {
      case 1:
        if (!formData.firstName.trim()) errors.firstName = 'First Name is required';
        if (!formData.lastName.trim()) errors.lastName = 'Last Name is required';
        if (!formData.email.trim()) {
          errors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
          errors.email = 'Email is invalid';
        }

        // Enhanced password validation
        if (!formData.password.trim()) {
          errors.password = 'Password is required';
        } else {
          const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

          if (!passwordRegex.test(formData.password)) {
            const validationErrors = [];

            if (formData.password.length < 8) {
              validationErrors.push('at least 8 characters');
            }
            if (!/(?=.*[a-z])/.test(formData.password)) {
              validationErrors.push('one lowercase letter');
            }
            if (!/(?=.*[A-Z])/.test(formData.password)) {
              validationErrors.push('one uppercase letter');
            }
            if (!/(?=.*\d)/.test(formData.password)) {
              validationErrors.push('one number');
            }
            if (!/(?=.*[@$!%*?&#])/.test(formData.password)) {
              validationErrors.push('one special character (@$!%*?&#)');
            }

            errors.password = `Password must contain: ${validationErrors.join(', ')}`;
          }
        }
        break;

        case 2:
          if (formData.selectedBroker === 'Groww') {
        
            if (!formData.growwApiKey.trim()) {
              errors.growwApiKey = 'API Key is required';
            }
        
            if (!formData.growwApiSecret.trim()) {
              errors.growwApiSecret = 'API Secret is required';
            }
        
            if (!formData.growwTotpToken.trim()) {
              errors.growwTotpToken = 'TOTP Token is required';
            }
        
            if (!formData.growwTotpQrToken.trim()) {
              errors.growwTotpQrToken = 'TOTP QR Token is required';
            }

            validateAccountName(errors);
        
          } else if (formData.selectedBroker === 'AngelOne') {
        
            if (!formData.angelClientCode.trim()) {
              errors.angelClientCode = 'Client ID is required';
            }
        
            if (!formData.angelPin.trim()) {
              errors.angelPin = 'PIN is required';
            } else if (!/^\d{4,6}$/.test(formData.angelPin)) {
              errors.angelPin = 'PIN must be 4-6 digits';
            }
        
            if (!formData.angelTotpKey.trim()) {
              errors.angelTotpKey = 'TOTP Key is required';
            }
        
            if (!formData.angelApiKey.trim()) {
              errors.angelApiKey = 'API Key is required';
            }
        
            if (!formData.angelSecretKey.trim()) {
              errors.angelSecretKey = 'Secret Key is required';
            }

            validateAccountName(errors);
        
          } else {
        
            if (!formData.userKey.trim()) {
              errors.userKey = 'User Key is required';
            }
        
            if (!formData.userId.trim()) {
              errors.userId = 'User ID is required';
            }
        
            if (!formData.pin.trim()) {
              errors.pin = 'PIN is required';
            } else if (!/^\d{4,6}$/.test(formData.pin)) {
              errors.pin = 'PIN must be 4-6 digits';
            }

            validateAccountName(errors);
        
          }
          break;
      case 3:
        if (!formData.encryptionKey.trim()) errors.encryptionKey = 'Encryption Key is required';
        if (!formData.clientCode.trim()) errors.clientCode = 'Client Code is required';
        if (!formData.totpKey.trim()) errors.totpKey = 'TOTP Key is required';
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // const nextStep = () => {
  //     if (validateStep(currentStep)) {
  //         setCompletedSteps(prev => [...prev, currentStep]);
  //         setCurrentStep(prev => prev + 1);
  //         setErrorMessage('');
  //     } else {
  //         setMessageType('error');
  //         setErrorMessage('Please fill in all required fields correctly');
  //     }
  // };
  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCompletedSteps(prev => [...prev, currentStep]);
      setCurrentStep(prev => Math.min(prev + 1, steps.length));
    } else {
      showErrorToast('Please fill in all required fields correctly');
    }
  };


  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
    setErrorMessage('');
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep(currentStep)) {
      showErrorToast('Please fill in all required fields correctly');
      return;
    }

    try {
      // const isGrowwBroker = formData.selectedBroker === 'Groww';
      const isGrowwBroker = formData.selectedBroker === 'Groww';
      const isAngelBroker = formData.selectedBroker === 'AngelOne';
      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        password: formData.password,
      
        broker_flag: isGrowwBroker
          ? 'grow'
          : isAngelBroker
            ? 'angelone'
            : '5paisa',

        account_name: formData.accountName.trim(),
      
        ...(isGrowwBroker
          ? {
              broker_user_id: generateGrowwBrokerUserId(),
              api_key: formData.growwApiKey,
              secret_key: formData.growwApiSecret,
              totp_token: formData.growwTotpToken,
              totp_qr_token: formData.growwTotpQrToken
            }
          : isAngelBroker
            ? {
                client_code: formData.angelClientCode,
                pin: formData.angelPin,
                totp_key: formData.angelTotpKey,
                api_key: formData.angelApiKey,
                secret_key: formData.angelSecretKey
              }
            : {
                broker_user_id: formData.userId,
                api_key: formData.userKey,
                secret_key: formData.totpKey,
                pin: formData.pin,
                encry_key: formData.encryptionKey,
                client_code: formData.clientCode
              })
      };

      const response = await fetch(`${pmsApiBaseUrl}/api/v1/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const normalizedStatus = String(data?.status || data?.data?.status || '')
        .trim()
        .toLowerCase();
      const apiMessage = data?.message || data?.data?.message || '';
      const isSuccess =
        normalizedStatus === 'success' ||
        /success/i.test(apiMessage);

      if (isSuccess) {
        showSuccessToast(apiMessage || 'Great! You\'ve successfully signed up.');

        // Clear all form fields on success
        setFormData(getEmptyFormData('5Paisa'));

        setTimeout(() => {
          navigate('/');
        }, 2000);
      } else {
        showErrorToast(apiMessage || 'Signup failed');

        // Clear all form fields on error
        setFormData(getEmptyFormData('5Paisa'));
      }
    } catch (error) {
      showErrorToast(error.message || 'An error occurred during signup');
    }
  };







  const isGrowwSelected = formData.selectedBroker === 'Groww';
const isAngelSelected = formData.selectedBroker === 'AngelOne';
const steps = isGrowwSelected
? [
    { id: 1, title: 'Personal Info', description: 'Basic Information' },
    { id: 2, title: 'Groww Keys', description: 'API Credentials' },
  ]
: isAngelSelected
  ? [
      { id: 1, title: 'Personal Info', description: 'Basic Information' },
      { id: 2, title: 'AngelOne Keys', description: 'API Credentials' },
    ]
  : [
      { id: 1, title: 'Personal Info', description: 'Basic Information' },
      { id: 2, title: 'Account Details', description: 'Trading Account' },
      { id: 3, title: 'Security Setup', description: 'Authentication' },
    ];

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="wizard_step_content">

            <div className="step_header">
              <div className="step_header_row">
                <h2 className="step_header_heading">Personal Information</h2>
               
              </div>
            </div>


            <div className="wizard_grid_2x2">
              <div className='wizard_field_row'>
                <label className="wizard_label">First Name</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><User size={18} /></div>
                  <input
                    type='text'
                    className={`wizard_input ${formErrors.firstName ? 'error' : ''}`}
                    name='firstName'
                    value={formData.firstName}
                    onChange={handleInputChange}
                    placeholder='Enter your first name'
                  />
                </div>
                {formErrors.firstName && <div className="wizard_error">{formErrors.firstName}</div>}
              </div>

              <div className='wizard_field_row'>
                <label className="wizard_label">Last Name</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><User size={18} /></div>
                  <input
                    type='text'
                    className={`wizard_input ${formErrors.lastName ? 'error' : ''}`}
                    name='lastName'
                    value={formData.lastName}
                    onChange={handleInputChange}
                    placeholder='Enter your last name'
                  />
                </div>
                {formErrors.lastName && <div className="wizard_error">{formErrors.lastName}</div>}
              </div>

              <div className='wizard_field_row'>
                <label className="wizard_label">Email Address</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><Mail size={18} /></div>
                  <input
                    type='email'
                    className={`wizard_input ${formErrors.email ? 'error' : ''}`}
                    name='email'
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder='Enter your email address'
                  />

                </div>

                {formErrors.email && <div className="wizard_error">{formErrors.email}</div>}
              </div>




              <div className='wizard_field_row'>
                <label className="wizard_label">Password</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><Lock size={18} /></div>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className={`wizard_input ${formErrors.password ? 'error' : ''}`}
                    name='password'
                    value={formData.password}
                    placeholder='Create a strong password'
                    onChange={handleInputChange}
                  />
                  <div className='wizard_icon_field' onClick={togglePasswordVisibility}>
                    {showPassword ? <PasswordShow /> : <PasswordHide />}
                  </div>
                </div>
                {formErrors.password && <div className="wizard_error">{formErrors.password}</div>}
                {!!formData.password &&
                  !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(formData.password) && (
                    <div className="wizard_hint">
                      Use 8+ characters with uppercase, lowercase, numbers & special characters (@$!%*?&#).
                    </div>
                  )}
              </div>
              {/* 
                          <div className='wizard_field_row'>
                            <label className="wizard_label">Select Broker</label>
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "8px",
                                border: "1px solid #E6EAF2",
                                borderRadius: "12px",
                                background: "#fff",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => handleBrokerTabChange("5Paisa")}
                                style={{
                                  border: formData.selectedBroker === "5Paisa" ? "1px solid #003092" : "1px solid transparent",
                                  background: formData.selectedBroker === "5Paisa" ? "#EEF4FF" : "#F8FAFC",
                                  borderRadius: "10px",
                                  padding: "8px 14px",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  minHeight: "44px",
                                }}
                              >
                                <img src={FivePaisaLogo} alt="5Paisa" style={{ width: "80px", height: "20px", objectFit: "contain" }} />
                              </button>

                              <button
                                type="button"
                                onClick={() => handleBrokerTabChange("Groww")}
                                style={{
                                  border: formData.selectedBroker === "Groww" ? "1px solid #003092" : "1px solid transparent",
                                  background: formData.selectedBroker === "Groww" ? "#EEF4FF" : "#F8FAFC",
                                  borderRadius: "10px",
                                  padding: "8px 14px",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  minHeight: "44px",
                                }}
                              >
                                <img src={GrowwLogo} alt="Groww" style={{ width: "80px", height: "20px", objectFit: "contain" }} />
                              </button>
                            </div>
                          </div> */}

            </div>
          </div>
        );

      case 2:
        return (
          <div className="wizard_step_content">
           <h2>
              {isGrowwSelected
                ? "Groww API Credentials"
                : isAngelSelected
                  ? "AngelOne API Credentials"
                  : "Account Details"}
            </h2>

            {isGrowwSelected ? (
              <div className="wizard_grid_2x2">
                <div className='wizard_field_row'>
                  <label className="wizard_label">API_KEY</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Key size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.growwApiKey ? 'error' : ''}`}
                      name='growwApiKey'
                      value={formData.growwApiKey}
                      onChange={handleInputChange}
                      placeholder='Enter Groww API Key'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalGrowwApiKey"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.growwApiKey && <div className="wizard_error">{formErrors.growwApiKey}</div>}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">API_SECRET</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Shield size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.growwApiSecret ? 'error' : ''}`}
                      name='growwApiSecret'
                      value={formData.growwApiSecret}
                      onChange={handleInputChange}
                      placeholder='Enter Groww API Secret'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalGrowwApiSecret"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.growwApiSecret && <div className="wizard_error">{formErrors.growwApiSecret}</div>}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">TOTP_TOKEN</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Shield size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.growwTotpToken ? 'error' : ''}`}
                      name='growwTotpToken'
                      value={formData.growwTotpToken}
                      onChange={handleInputChange}
                      placeholder='Enter Groww TOTP Token'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalGrowwTotpCredentials"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.growwTotpToken && (
                    <div className="wizard_error">{formErrors.growwTotpToken}</div>
                  )}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">TOTP_QR_TOKEN</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Shield size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.growwTotpQrToken ? 'error' : ''}`}
                      name='growwTotpQrToken'
                      value={formData.growwTotpQrToken}
                      onChange={handleInputChange}
                      placeholder='Enter Groww TOTP QR Token'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalGrowwTotpCredentials"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.growwTotpQrToken && (
                    <div className="wizard_error">{formErrors.growwTotpQrToken}</div>
                  )}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">Account Name</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Tag size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.accountName ? 'error' : ''}`}
                      name='accountName'
                      value={formData.accountName}
                      onChange={handleInputChange}
                      placeholder='e.g. Long Term'
                      maxLength="40"
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAccountName"
                      aria-label="Help with account name"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.accountName && (
                    <div className="wizard_error">{formErrors.accountName}</div>
                  )}
                </div>

              </div>
            ) : isAngelSelected ? (
              <div className="wizard_grid_2x2">
            
                <div className='wizard_field_row'>
                  <label className="wizard_label">Client ID [Client Code]</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><CreditCard size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.angelClientCode ? 'error' : ''}`}
                      name='angelClientCode'
                      value={formData.angelClientCode}
                      onChange={handleInputChange}
                      placeholder='Enter AngelOne Client ID'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAngelClientCode"
                      aria-label="Help with Client ID"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.angelClientCode && (
                    <div className="wizard_error">{formErrors.angelClientCode}</div>
                  )}
                </div>
            
                <div className='wizard_field_row'>
                  <label className="wizard_label">PIN</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Smartphone size={18} /></div>
                    <input
                      type='password'
                      className={`wizard_input ${formErrors.angelPin ? 'error' : ''}`}
                      name='angelPin'
                      value={formData.angelPin}
                      onChange={handleInputChange}
                      placeholder='Enter AngelOne PIN'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAngelPin"
                      aria-label="Help with PIN"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.angelPin && (
                    <div className="wizard_error">{formErrors.angelPin}</div>
                  )}
                </div>
            
                <div className='wizard_field_row'>
                  <label className="wizard_label">TOTP Key</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Shield size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.angelTotpKey ? 'error' : ''}`}
                      name='angelTotpKey'
                      value={formData.angelTotpKey}
                      onChange={handleInputChange}
                      placeholder='Enter AngelOne TOTP Key'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAngelTotpKey"
                      aria-label="Help with TOTP Key"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.angelTotpKey && (
                    <div className="wizard_error">{formErrors.angelTotpKey}</div>
                  )}
                </div>
            
                <div className='wizard_field_row'>
                  <label className="wizard_label">API Key</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Key size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.angelApiKey ? 'error' : ''}`}
                      name='angelApiKey'
                      value={formData.angelApiKey}
                      onChange={handleInputChange}
                      placeholder='Enter AngelOne API Key'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAngelApiKey"
                      aria-label="Help with API Key"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.angelApiKey && (
                    <div className="wizard_error">{formErrors.angelApiKey}</div>
                  )}
                </div>
            
                <div className='wizard_field_row'>
                  <label className="wizard_label">Secret Key</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Shield size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.angelSecretKey ? 'error' : ''}`}
                      name='angelSecretKey'
                      value={formData.angelSecretKey}
                      onChange={handleInputChange}
                      placeholder='Enter AngelOne Secret Key'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAngelSecretKey"
                      aria-label="Help with Secret Key"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.angelSecretKey && (
                    <div className="wizard_error">{formErrors.angelSecretKey}</div>
                  )}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">Account Name</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Tag size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.accountName ? 'error' : ''}`}
                      name='accountName'
                      value={formData.accountName}
                      onChange={handleInputChange}
                      placeholder='e.g. Long Term'
                      maxLength="40"
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAccountName"
                      aria-label="Help with account name"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.accountName && (
                    <div className="wizard_error">{formErrors.accountName}</div>
                  )}
                </div>
            
              </div>
            ) : (
              <div className="wizard_grid_2x2">
                <div className='wizard_field_row'>
                  <label className="wizard_label">User/API Key</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Key size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.userKey ? 'error' : ''}`}
                      name='userKey'
                      value={formData.userKey}
                      onChange={handleInputChange}
                      placeholder='Enter your user key'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#Modal1UserKey"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.userKey && <div className="wizard_error">{formErrors.userKey}</div>}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">User ID</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Hash size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.userId ? 'error' : ''}`}
                      name='userId'
                      value={formData.userId}
                      onChange={handleInputChange}
                      placeholder='Enter your user ID'
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#Modal1UserId"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.userId && <div className="wizard_error">{formErrors.userId}</div>}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">PIN</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Smartphone size={18} /></div>
                    <input
                      type='password'
                      className={`wizard_input ${formErrors.pin ? 'error' : ''}`}
                      name='pin'
                      value={formData.pin}
                      onChange={handleInputChange}
                      placeholder='Enter 4-6 digit PIN'
                      maxLength="6"
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#Modal1UserPin"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.pin && <div className="wizard_error">{formErrors.pin}</div>}
                </div>

                <div className='wizard_field_row'>
                  <label className="wizard_label">Account Name</label>
                  <div className='wizard_text_field'>
                    <div className='wizard_icon_input'><Tag size={18} /></div>
                    <input
                      type='text'
                      className={`wizard_input ${formErrors.accountName ? 'error' : ''}`}
                      name='accountName'
                      value={formData.accountName}
                      onChange={handleInputChange}
                      placeholder='e.g. Long Term'
                      maxLength="40"
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      className='wizard_field_help'
                      data-bs-toggle="modal"
                      data-bs-target="#ModalAccountName"
                      aria-label="Help with account name"
                    >
                      <FaRegQuestionCircle size={18} aria-hidden />
                    </button>
                  </div>
                  {formErrors.accountName && (
                    <div className="wizard_error">{formErrors.accountName}</div>
                  )}
                </div>
              </div>
            )}
          </div>
        );

      case 3:
        return (
          <div className="wizard_step_content">
            <div className="step_header">
              <h2>Security Setup</h2>
            </div>

            <div className="wizard_grid_2x2">
              <div className='wizard_field_row'>
                <label className="wizard_label">Encryption Key</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><Key size={18} /></div>
                  <input
                    type='text'
                    className={`wizard_input ${formErrors.encryptionKey ? 'error' : ''}`}
                    name='encryptionKey'
                    value={formData.encryptionKey}
                    onChange={handleInputChange}
                    placeholder='Enter encryption key'
                  />
                  <button
                    type="button"
                    className='wizard_field_help'
                    data-bs-toggle="modal"
                    data-bs-target="#Modal1UserEncKey"
                  >
                    <FaRegQuestionCircle size={18} aria-hidden />
                  </button>
                </div>
                {formErrors.encryptionKey && <div className="wizard_error">{formErrors.encryptionKey}</div>}
              </div>

              <div className='wizard_field_row'>
                <label className="wizard_label">Client Code</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><CreditCard size={18} /></div>
                  <input
                    type='text'
                    className={`wizard_input ${formErrors.clientCode ? 'error' : ''}`}
                    name='clientCode'
                    value={formData.clientCode}
                    onChange={handleInputChange}
                    placeholder='Enter client code'
                  />
                  <button
                    type="button"
                    className='wizard_field_help'
                    data-bs-toggle="modal"
                    data-bs-target="#Modal1UserClientCode"
                  >
                    <FaRegQuestionCircle size={18} aria-hidden />
                  </button>
                </div>
                {formErrors.clientCode && <div className="wizard_error">{formErrors.clientCode}</div>}
              </div>

              <div className='wizard_field_row'>
                <label className="wizard_label">TOTP Key</label>
                <div className='wizard_text_field'>
                  <div className='wizard_icon_input'><Shield size={18} /></div>
                  <input
                    type='text'
                    className={`wizard_input ${formErrors.totpKey ? 'error' : ''}`}
                    name='totpKey'
                    value={formData.totpKey}
                    onChange={handleInputChange}
                    placeholder='Enter TOTP key'
                  />
                  <button
                    type="button"
                    className='wizard_field_help'
                    data-bs-toggle="modal"
                    data-bs-target="#Modal1UserTOTP"
                  >
                    <FaRegQuestionCircle size={18} aria-hidden />
                  </button>
                </div>
                {formErrors.totpKey && <div className="wizard_error">{formErrors.totpKey}</div>}
              </div>

              <div className='wizard_field_row'>
                {/* Empty div to maintain 2x2 grid */}
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="login-page signup-wizard">
        <div className="login-page__backdrop" aria-hidden>
          <span className="login-page__orb login-page__orb--1" />
          <span className="login-page__orb login-page__orb--2" />
          <span className="login-page__orb login-page__orb--3" />
        </div>
        <main className="login-page__main signup-wizard__main">
          <div className="wizard_container">
            {/* Header — brand left, title + description right */}
            <div className="wizard_header signup-wizard__hero">
              <div className="signup-wizard__hero-brand">
                <div className="wizard_logo">
                  <img src={Logo} alt="Infomanav" className="signup-wizard__brand-logo" />
                </div>
              </div>
              <div className="signup-wizard__hero-copy">
                <h1 className="wizard_title">Create Account</h1>
                <p className="wizard_subtitle">Select the broker you want to sign up with:</p>
              </div>
            </div>

            {/* Broker tabs - full width equal split */}
            <div className="signup-wizard__broker-row">
              <div className="signup-wizard__broker-tabs" role="tablist" aria-label="Choose broker">
                {[
                  { key: "5Paisa", logo: FivePaisaLogo, alt: "5Paisa" },
                  { key: "Groww", logo: GrowwLogo, alt: "Groww" },
                  { key: "AngelOne", logo: AngelOneLogo, alt: "AngelOne" }, // AngelOneLogo
                ].map((brokerItem) => {
                  const isActive = formData.selectedBroker === brokerItem.key;
                  return (
                    <button
                      key={brokerItem.key}
                      type="button"
                      role="tab"
                      aria-selected={isActive}
                      className={`signup-wizard__broker-tab${isActive ? " signup-wizard__broker-tab--active" : ""}`}
                      onClick={() => { handleBrokerTabChange(brokerItem.key); setCurrentStep(1); }}
                    >
                      <img
                        src={brokerItem.logo}
                        alt={brokerItem.alt}
                        className={`signup-wizard__broker-tab-logo signup-wizard__broker-tab-logo--${
                          brokerItem.key === "5Paisa"
                            ? "fivepaisa"
                            : brokerItem.key === "Groww"
                              ? "groww"
                              : "angelone"
                        }`}
                      />
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Progress Steps */}
            <div
              className="wizard_progress signup-wizard__wizard-progress"
              style={{ "--signup-steps": steps.length }}
            >
              <div className="progress_bar">
                <div
                  className="progress_fill"
                  style={{
                    width: `${steps.length > 1 ? ((currentStep - 1) / (steps.length - 1)) * 100 : 0}%`,
                  }}
                ></div>
              </div>
              <div className="steps_container">
                {steps.map((step, index) => {
                  const stepPos =
                    index === 0 ? 'first' : index === steps.length - 1 ? 'last' : 'mid';
                  const denom = Math.max(steps.length - 1, 1);
                  return (
                    <div
                      key={step.id}
                      data-step-pos={stepPos}
                      className={`step_item ${currentStep === step.id ? 'active' : ''} ${completedSteps.includes(step.id) ? 'completed' : ''}`}
                      onClick={() => currentStep > step.id && setCurrentStep(step.id)}
                      style={{
                        '--step-i': index,
                        '--step-denom': denom,
                      }}
                    >
                      <div className="step_circle">
                        {completedSteps.includes(step.id) ? (
                          <Check size={16} />
                        ) : (
                          <span>{step.id}</span>
                        )}
                      </div>
                      <div className="step_info">
                        <div className="step_title">{step.title}</div>
                        <div className="step_description">{step.description}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Step Content */}
            <div className="wizard_content">
              <form onSubmit={currentStep === steps.length ? handleSubmit : (e) => { e.preventDefault(); nextStep(); }}>
                {renderStepContent()}

                {/* Navigation Buttons */}
                <div className="wizard_navigation">
                  {currentStep > 1 && (
                    <button type="button" onClick={prevStep} className="wizard_btn wizard_btn_secondary">
                      <ChevronLeft size={18} />
                      Previous
                    </button>
                  )}

                  <div className="wizard_btn_group">
                    {currentStep < steps.length ? (
                      <button type="submit" className="wizard_btn wizard_btn_primary">
                        {currentStep === 1
                          ? `Proceed with ${
                              formData.selectedBroker === "5Paisa"
                                ? "5paisa"
                                : formData.selectedBroker === "Groww"
                                  ? "Groww"
                                  : "AngelOne"
                            }`
                          : "Continue"}
                        {/* <ChevronRight size={18} /> */}
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmit}
                        type="submit" className="wizard_btn wizard_btn_primary">
                        <Check size={18} />
                        Create Account
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>

            {/* Footer */}
            <div className="wizard_footer">
              <p className="signup-wizard__footer-line">Already have an Account? <span className='text_primary_color cursor_pointer' onClick={() => navigate('/')}>Sign In</span></p>
            </div>
          </div>
        </main>
      </div>





      {/* ModalGrowwApiKey - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="ModalGrowwApiKey" aria-labelledby="ModalGrowwApiKeyLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="ModalGrowwApiKeyLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials (Groww)
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Get Your API Credentials (Groww)
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to obtain your API Key and Secret:
              </h5>

              <div
                className="p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>1. Sign in to Groww</strong><br />
                  Log in to your Groww account and navigate to the Trade API section.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>2. Choose an API Plan</strong><br />
                  Select an available plan (Free Trial or Paid) and complete the onboarding process.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>3. Create an Application</strong><br />
                  Go to the Developer Dashboard and create a new application by providing a name and required details.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>4. Generate API Credentials</strong><br />
                  Once the application is created, your credentials will be displayed:
                  <br />- API Key
                  <br />- API Secret
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>5. Enable API Access (Important)</strong><br />
                  Ensure your API key is approved/enabled from the Groww dashboard (if required).
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>6. Use in Your Application</strong><br />
                  Copy the API Key and Secret and enter them in the respective fields in this application.
                </p>
              </div>

              <p
                className="mb-0 mt-4 p-3"
                style={{
                  backgroundColor: "#FFF7ED",
                  borderRadius: "8px",
                  color: "#5A5A5A",
                  lineHeight: "1.6",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <strong style={{ color: "#003092" }}>Note:</strong> The API Secret may be shown only once. Please store it securely.
              </p>
            </div>

            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>


      {/* ModalGrowwApiSecret - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="ModalGrowwApiSecret" aria-labelledby="ModalGrowwApiSecretLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="ModalGrowwApiSecretLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials (Groww)
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Get Your API Credentials (Groww)
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to obtain your API Key and Secret:
              </h5>

              <div
                className="p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>1. Sign in to Groww</strong><br />
                  Log in to your Groww account and navigate to the Trade API section.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>2. Choose an API Plan</strong><br />
                  Select an available plan (Free Trial or Paid) and complete the onboarding process.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>3. Create an Application</strong><br />
                  Go to the Developer Dashboard and create a new application by providing a name and required details.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>4. Generate API Credentials</strong><br />
                  Once the application is created, your credentials will be displayed:
                  <br />- API Key
                  <br />- API Secret
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>5. Enable API Access (Important)</strong><br />
                  Ensure your API key is approved/enabled from the Groww dashboard (if required).
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>6. Use in Your Application</strong><br />
                  Copy the API Key and Secret and enter them in the respective fields in this application.
                </p>
              </div>

              <p
                className="mb-0 mt-4 p-3"
                style={{
                  backgroundColor: "#FFF7ED",
                  borderRadius: "8px",
                  color: "#5A5A5A",
                  lineHeight: "1.6",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <strong style={{ color: "#003092" }}>Note:</strong> The API Secret may be shown only once. Please store it securely.
              </p>
            </div>

            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>


      {/* ModalGrowwTotpCredentials - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="ModalGrowwTotpCredentials" aria-labelledby="ModalGrowwTotpCredentialsLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="ModalGrowwTotpCredentialsLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your TOTP Credentials (Groww)
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Get Your TOTP Credentials (Groww)
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                After obtaining your API Key and Secret, follow these steps to get your TOTP credentials:
              </h5>

              <div
                className="p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>1. Sign in to Groww</strong><br />
                  Log in to your Groww account and navigate to the Trade API section.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>2. Choose an API Plan</strong><br />
                  Select an available plan (Free Trial or Paid) and complete the onboarding process.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>3. Create an Application</strong><br />
                  Go to the Developer Dashboard and create a new application by providing a name and required details.
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>4. Generate TOTP Credentials</strong><br />
                  Once the application is created, your credentials will be displayed:
                  <br />- TOTP_TOKEN
                  <br />- TOTP_QR_TOKEN
                </p>
                <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>5. Enable API Access (Important)</strong><br />
                  Ensure your API key is approved/enabled from the Groww dashboard (if required).
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  <strong>6. Use in Your Application</strong><br />
                  Copy the TOTP_TOKEN and TOTP_QR_TOKEN and enter them in the respective fields in this application.
                </p>
              </div>

              <p
                className="mb-0 mt-4 p-3"
                style={{
                  backgroundColor: "#FFF7ED",
                  borderRadius: "8px",
                  color: "#5A5A5A",
                  lineHeight: "1.6",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <strong style={{ color: "#003092" }}>Note:</strong> The TOTP credentials may be shown only once. Please store them securely.
              </p>
            </div>

            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>


      {/* AngelOne help modals */}
      <PremiumHelpModal
        id="ModalAngelClientCode"
        labelId="ModalAngelClientCodeLabel"
        title="How to Get Your Client ID (AngelOne)"
        subtitle="Find your Client ID (Client Code) from your Angel One account:"
      >
        <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>Account → View Profile</strong><br />
          Open your Angel One account, go to <strong>Account</strong>, then select <strong>View Profile</strong>. Your Client ID (Client Code) is shown there.
        </p>
      </PremiumHelpModal>

      <PremiumHelpModal
        id="ModalAngelPin"
        labelId="ModalAngelPinLabel"
        title="How to Get Your PIN (AngelOne)"
        subtitle="Your trading PIN is set during account setup:"
      >
        <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          The <strong>4-digit trading PIN</strong> you created during your Angel One account setup. This is the same PIN you use for trading authentication.
        </p>
      </PremiumHelpModal>

      <PremiumHelpModal
        id="ModalAngelTotpKey"
        labelId="ModalAngelTotpKeyLabel"
        title="How to Get Your TOTP Key (AngelOne)"
        subtitle="Follow these steps to obtain your TOTP Key:"
        note={
          <>
            <strong style={{ color: "#003092" }}>Note:</strong> Store the secret key (Base32 string), not the 6-digit OTP. The TOTP Key may be shown only once.
          </>
        }
      >
        <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>1. Enable TOTP via Smart API</strong><br />
          Go to <strong>AngelOne Smart API → Enable TOTP</strong>, enter your Client ID and PIN, then enter the OTP sent to you. You will receive your TOTP Key.
        </p>
        <p className="mb-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>2. During TOTP Setup</strong><br />
          Enable TOTP in Angel One. During setup, you&apos;ll get a QR code or a manual secret key. Store the <strong>secret key (Base32 string)</strong>, not the 6-digit OTP.
        </p>
        <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>Example format:</strong><br />
          <code style={{ color: "#003092", wordBreak: "break-all" }}>FVB5GRK6QSVCQ4FKQQM2FAQXSA</code>
        </p>
      </PremiumHelpModal>

      <PremiumHelpModal
        id="ModalAngelApiKey"
        labelId="ModalAngelApiKeyLabel"
        title="How to Get Your API Key (AngelOne)"
        subtitle="Obtain your API Key from the AngelOne Smart API portal:"
      >
        <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>AngelOne Smart API → Login → Get API Key</strong><br />
          Sign in to the AngelOne Smart API portal, then navigate to get your API Key.
        </p>
      </PremiumHelpModal>

      <PremiumHelpModal
        id="ModalAngelSecretKey"
        labelId="ModalAngelSecretKeyLabel"
        title="How to Get Your Secret Key (AngelOne)"
        subtitle="Obtain your Secret Key when creating an app:"
        note={
          <>
            <strong style={{ color: "#003092" }}>Note:</strong> The Secret Key is usually only shown when the app is created. If you didn&apos;t save it and the portal doesn&apos;t display it, you need to create a new app.
          </>
        }
      >
        <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
          <strong>AngelOne Smart API → Login → Add App → Secret Key</strong><br />
          Sign in to the AngelOne Smart API portal, add a new app, and copy the Secret Key when it is displayed.
        </p>
      </PremiumHelpModal>


      {/* ModalAccountName — 5paisa display name help */}
      <div
        className="modal fade"
        id="ModalAccountName"
        aria-labelledby="ModalAccountNameLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered signup-help-modal__dialog">
          <div className="modal-content signup-help-modal border-0 shadow-lg">
            <div className="modal-header signup-help-modal__header border-0">
              <div className="signup-help-modal__header-text">
                <h2 className="signup-help-modal__title" id="ModalAccountNameLabel">
                  What is Account Name?
                </h2>
                <div className="signup-help-modal__title-accent" aria-hidden="true" />
              </div>
              <button
                type="button"
                className="btn-close signup-help-modal__close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body signup-help-modal__body">
              <p className="signup-help-modal__lead">
                After login, this name is shown in the app <strong>instead of the broker name</strong>.
              </p>
              <div className="signup-help-modal__panel">
                <ul className="signup-help-modal__sublist" style={{ margin: 0 }}>
                  <li>You can name it anything meaningful to you — e.g. <strong>Long Term</strong>, <strong>Intraday</strong>, or <strong>Family</strong>.</li>
                  <li>Must be at least <strong>3 characters</strong> (max 40).</li>
                  <li>Letters, numbers, spaces, hyphens, and underscores are allowed.</li>
                </ul>
              </div>
            </div>

            <div className="modal-footer border-0 pt-0 pb-3 px-4">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                style={{
                  border: "1px solid #003092",
                  color: "#003092",
                  borderRadius: "8px",
                  fontWeight: 600,
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal1UserMain — signup credentials guide */}
      <div className="modal fade" id="Modal1UserMain" aria-labelledby="Modal1UserMainLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div className="modal-content signup-help-modal border-0 shadow-lg">
            <div className="modal-header signup-help-modal__header border-0">
              <div className="signup-help-modal__header-text">
                <h2 className="signup-help-modal__title" id="Modal1UserMainLabel">
                  How to Get Your Sign Up Credentials
                </h2>
                <div className="signup-help-modal__title-accent" aria-hidden="true" />
              </div>
              <button
                type="button"
                className="btn-close signup-help-modal__close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body signup-help-modal__body">
              <p className="signup-help-modal__lead">
                How to Sign Up on 5paisa &amp; Get Your API Credentials
              </p>
              <h3 className="signup-help-modal__section">Create a 5paisa Trading Account</h3>

              <div className="signup-help-modal__panel">
                <ol className="signup-help-modal__steps">
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num" aria-hidden="true">1</span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">
                        Visit the <strong>5paisa website</strong>.
                      </p>
                    </div>
                  </li>
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num" aria-hidden="true">2</span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">
                        Click <strong>&quot;Open an Account&quot;</strong>.
                      </p>
                    </div>
                  </li>
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num" aria-hidden="true">3</span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">
                        Complete the registration process using your{' '}
                        <strong>PAN, Aadhaar, and bank details</strong>.
                      </p>
                    </div>
                  </li>
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num" aria-hidden="true">4</span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">
                        Once approved, you&apos;ll receive your{' '}
                        <strong className="signup-help-modal__accent-strong">Client Code</strong> on your{' '}
                        <strong>Registered Email</strong>.
                      </p>
                    </div>
                  </li>
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num" aria-hidden="true">5</span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">
                        After your account is approved (usually within 1–2 days), you&apos;ll receive a{' '}
                        <strong>Welcome Email/SMS</strong> from 5paisa.
                      </p>
                    </div>
                  </li>
                  <li className="signup-help-modal__step">
                    <span className="signup-help-modal__step-num signup-help-modal__step-num--accent" aria-hidden="true">
                      6
                    </span>
                    <div className="signup-help-modal__step-body">
                      <p className="signup-help-modal__step-text">The email includes:</p>
                      <ul className="signup-help-modal__sublist">
                        <li>
                          Your <strong className="signup-help-modal__accent-strong">Client Code</strong> (e.g., XYZ123)
                        </li>
                        <li>
                          Your <strong className="signup-help-modal__accent-strong">User ID</strong>
                        </li>
                        <li>Login instructions for the 5paisa app and website</li>
                      </ul>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Modal1UserKey - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserKey" aria-labelledby="Modal1UserKeyLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Find Your API Keys: User Key
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get your API credentials:
              </h5>

              {/* Step-by-step instructions */}
              <div
                className="p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      1
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      After signing up on 5paisa, wait for approval (usually takes 1–2 days).
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      2
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Once approved, log in to <strong>5paisa XStream</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      3
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      After login, you'll land on the dashboard.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      4
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Click on your <strong>name/client code</strong> in the top-right corner to open a dropdown menu.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      5
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      From the sidebar, go to <strong style={{ color: "#003092" }}>Developer's API → Get API Keys</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      6
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      You'll now see a page showing your <strong style={{ color: "#003092" }}>User Key</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-0">
                  <div className="d-flex align-items-start">
                    <span
                      style={{
                        backgroundColor: "#FFAB5B",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      7
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Copy it and enter them in the required fields.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>




      {/* Modal1UserId - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserId" aria-labelledby="Modal1UserIdLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Find Your API Keys: User ID
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get your API credentials:
              </h5>

              {/* Option 1 */}
              <div
                className="mb-4"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B",
                  padding: "20px"
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <span
                    style={{
                      backgroundColor: "#003092",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      fontSize: "13px",
                      fontWeight: "600",
                      marginRight: "12px"
                    }}
                  >
                    OPTION 1
                  </span>
                  <h6
                    className="fw-semibold mb-0"
                    style={{
                      color: "#003092",
                      fontSize: "15px"
                    }}
                  >
                    Check Your Welcome Email
                  </h6>
                </div>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • After your account is approved (usually within 1–2 days), you'll receive a <strong>Welcome Email/SMS</strong> from 5paisa.
                </p>
                <p className="mb-0 ms-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • The email includes:<br />
                  &nbsp;&nbsp;&nbsp;• Your Client Code (e.g., XYZ123)<br />
                  &nbsp;&nbsp;&nbsp;• Your <strong style={{ color: "#003092" }}>User ID</strong><br />
                  &nbsp;&nbsp;&nbsp;• Login instructions for the 5paisa app and website
                </p>
              </div>

              {/* Option 2 */}
              <div
                className="mb-0"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B",
                  padding: "20px"
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <span
                    style={{
                      backgroundColor: "#003092",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      fontSize: "13px",
                      fontWeight: "600",
                      marginRight: "12px"
                    }}
                  >
                    OPTION 2
                  </span>
                  <h6
                    className="fw-semibold mb-0"
                    style={{
                      color: "#003092",
                      fontSize: "15px"
                    }}
                  >
                    Find It Manually
                  </h6>
                </div>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • After signing up on 5paisa, wait for approval (usually takes 1–2 days).
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Once approved, log in to <strong>5paisa XStream</strong>.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • After login, you'll land on the dashboard.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Click on your <strong>name/client code</strong> in the top-right corner to open a dropdown menu.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • From the sidebar, go to <strong style={{ color: "#003092" }}>Developer's API → Get API Keys</strong>.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • You'll now see a page showing your <strong style={{ color: "#003092" }}>User ID</strong>.
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Copy it and enter them in the required fields.
                </p>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Modal1UserPin - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserPin" aria-labelledby="Modal1UserPinLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Get or Reset Your 5paisa Trading PIN
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get/reset your PIN:
              </h5>

              {/* Option 1 */}
              <div
                className="mb-4"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B",
                  padding: "20px"
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <span
                    style={{
                      backgroundColor: "#003092",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      fontSize: "13px",
                      fontWeight: "600",
                      marginRight: "12px"
                    }}
                  >
                    OPTION 1
                  </span>
                  <h6
                    className="fw-semibold mb-0"
                    style={{
                      color: "#003092",
                      fontSize: "15px"
                    }}
                  >
                    When Setting Up Your Account (Initial Setup)
                  </h6>
                </div>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • During your first-time login after account approval, 5paisa will ask you to set a <strong>4-digit Trading PIN</strong>.
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Make sure to save or note it down safely, as this PIN will be used for TOTP setup and trading actions.
                </p>
              </div>

              {/* Option 2 */}
              <div
                className="mb-4"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B",
                  padding: "20px"
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <span
                    style={{
                      backgroundColor: "#003092",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      fontSize: "13px",
                      fontWeight: "600",
                      marginRight: "12px"
                    }}
                  >
                    OPTION 2
                  </span>
                  <h6
                    className="fw-semibold mb-0"
                    style={{
                      color: "#003092",
                      fontSize: "15px"
                    }}
                  >
                    Reset via Website (Desktop)
                  </h6>
                </div>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Login to your 5paisa account on the website.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Click your <strong>name / client code</strong> in the top-right menu.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Go to <strong>Security</strong> or <strong>Login & Security</strong>.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Select <strong>"Forgot PIN"</strong>.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Verify OTP sent to your registered mobile/email.
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Set a new PIN.
                </p>
              </div>

              {/* Option 3 */}
              <div
                className="mb-0"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B",
                  padding: "20px"
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <span
                    style={{
                      backgroundColor: "#003092",
                      color: "white",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      fontSize: "13px",
                      fontWeight: "600",
                      marginRight: "12px"
                    }}
                  >
                    OPTION 3
                  </span>
                  <h6
                    className="fw-semibold mb-0"
                    style={{
                      color: "#003092",
                      fontSize: "15px"
                    }}
                  >
                    If You Forgot Your PIN (Reset via App)
                  </h6>
                </div>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • On the login screen, click <strong>"Forgot Password / PIN"</strong>.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Select the PIN reset option.
                </p>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Verify OTP.
                </p>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Set a new PIN and proceed to login.
                </p>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Modal1UserEncKey - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserEncKey" aria-labelledby="Modal1UserEncKeyLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              overflowY: "auto",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Find Your API Keys: Encryption Key
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get your API credentials:
              </h5>

              {/* Step-by-step instructions */}
              <div
                className="p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      1
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      After signing up on 5paisa, wait for approval (usually takes 1–2 days).
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      2
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Once approved, log in to <strong>5paisa XStream</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      3
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      After login, you'll land on the dashboard.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      4
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Click on your <strong>name/client code</strong> in the top-right corner to open a dropdown menu.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      5
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      From the sidebar, go to <strong style={{ color: "#003092" }}>Developer's API → Get API Keys</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="d-flex align-items-start mb-2">
                    <span
                      style={{
                        backgroundColor: "#003092",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      6
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      You'll now see a page showing your <strong style={{ color: "#003092" }}>Encryption Key</strong>.
                    </p>
                  </div>
                </div>

                <div className="mb-0">
                  <div className="d-flex align-items-start">
                    <span
                      style={{
                        backgroundColor: "#FFAB5B",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px",
                        marginRight: "12px",
                        flexShrink: 0,
                        marginTop: "2px"
                      }}
                    >
                      7
                    </span>
                    <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                      Copy it and enter them in the required fields.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Modal1UserClientCode - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserClientCode" aria-labelledby="Modal1UserClientCodeLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Get Your 5paisa Client Code
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get your API credentials:
              </h5>

              <p
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  color: "#5A5A5A",
                  lineHeight: "1.6",
                  borderLeft: "4px solid #003092"
                }}
              >
                Your <strong>Client Code</strong> is a unique 6-character identifier assigned to you when your 5paisa trading account is opened.
              </p>

              {/* Option 1 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-3"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  Option 1: Check Your Welcome Email
                </h6>
                <p className="mb-2" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • After your account is approved (usually within 1–2 days), you'll receive a <strong>Welcome Email/SMS</strong> from 5paisa.
                </p>
                <p className="mb-0 ms-3" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • The email includes:<br />
                  &nbsp;&nbsp;&nbsp;• Your <strong style={{ color: "#003092" }}>Client Code</strong> (e.g., XYZ123)<br />
                  &nbsp;&nbsp;&nbsp;• Your User ID<br />
                  &nbsp;&nbsp;&nbsp;• Login instructions for the 5paisa app and website
                </p>
              </div>

              {/* Option 2 */}
              <div
                className="mb-0 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-3"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  Option 2: Find It Manually
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Visit the 5paisa website and log in.<br />
                  • Once on the dashboard, look at the <strong>top-right corner</strong>.<br />
                  • You'll see your name and client code listed there.<br />
                  • It's typically shown as something like: <span style={{
                    backgroundColor: "#003092",
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    fontSize: "13px",
                    fontWeight: "500"
                  }}>Welcome, John (Client Code: XYZ123)</span>
                </p>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Modal1UserTOTP - Premium Design */}
      <div className="modal fade signup-wizard-help-modal" id="Modal1UserTOTP" aria-labelledby="Modal1UserTOTPLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg signup-help-modal__dialog">
          <div
            className="modal-content shadow-lg border-0"
            style={{
              maxHeight: "700px",
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              backgroundColor: "#F4F6F9"
            }}
          >
            {/* Sticky Header */}
            <div
              className="modal-header border-0"
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "12px 12px 0 0",
                padding: "24px 32px 16px 32px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <div style={{ width: "100%" }}>
                <h5
                  className="modal-title mb-0"
                  id="scrollableModalLabel"
                  style={{
                    color: "#003092",
                    fontSize: "24px",
                    fontWeight: "600",
                    letterSpacing: "-0.5px"
                  }}
                >
                  How to Get Your API Credentials
                </h5>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#FFAB5B",
                    marginTop: "12px",
                    borderRadius: "2px"
                  }}
                ></div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginTop: "-8px"
                }}
              ></button>
            </div>

            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                padding: "32px",
                backgroundColor: "white",
                margin: "10px 16px 16px 16px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)"
              }}
            >
              <h2
                style={{
                  color: "#003092",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "20px"
                }}
              >
                How to Enable TOTP (2FA) & Get Your TOTP Key
              </h2>

              <h5
                className="fw-semibold mb-4"
                style={{
                  color: "#003092",
                  fontSize: "16px"
                }}
              >
                Follow these steps to get your TOTP Key:
              </h5>

              {/* Step 1 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  1. Login to 5paisa Website
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Use your credentials to log in.
                </p>
              </div>

              {/* Step 2 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  2. Go to Profile
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • After login, you'll land on the Dashboard.<br />
                  • Click your name or client code at the top-right corner.<br />
                  • From the dropdown, select <strong>Profile</strong>.
                </p>
              </div>

              {/* Step 3 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  3. Open TOTP Settings
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • In your profile, find and click <strong>TOTP</strong> (or "External 2FA TOTP").
                </p>
              </div>

              {/* Step 4 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  4. Disable If Already Enabled
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • If External TOTP is already enabled:<br />
                  &nbsp;&nbsp;- Click <strong>Disable</strong><br />
                  &nbsp;&nbsp;- Enter the OTP sent via SMS/Email<br />
                  &nbsp;&nbsp;- Enter your Trading PIN<br />
                  &nbsp;&nbsp;- Once disabled, return to this page
                </p>
              </div>

              {/* Step 5 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  5. Enable TOTP
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Click <strong>Enable External TOTP</strong><br />
                  • Enter the OTP and Trading PIN again
                </p>
              </div>

              {/* Step 6 */}
              <div
                className="mb-4 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  6. Get Your TOTP Key
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • You will now see a QR Code and a Secret Key<br />
                  • Enter the OTP and Trading PIN again<br />
                  • Copy the Secret Key — this is your <strong style={{ color: "#003092" }}>TOTP Key</strong><br />
                  • Scan the QR Code using any TOTP app:<br />
                  &nbsp;&nbsp;- Google Authenticator<br />
                  &nbsp;&nbsp;- Authy<br />
                  &nbsp;&nbsp;- Microsoft Authenticator<br />
                  &nbsp;&nbsp;- (Any TOTP-compatible app)
                </p>
              </div>

              {/* Step 7 */}
              <div
                className="mb-0 p-3"
                style={{
                  backgroundColor: "#F4F6F9",
                  borderRadius: "8px",
                  borderLeft: "4px solid #FFAB5B"
                }}
              >
                <h6
                  className="fw-semibold mb-2"
                  style={{
                    color: "#003092",
                    fontSize: "15px"
                  }}
                >
                  7. Activate
                </h6>
                <p className="mb-0" style={{ color: "#5A5A5A", lineHeight: "1.6" }}>
                  • Your app will generate a 6-digit code that refreshes every ~30 seconds<br />
                  • Enter the code into the 5paisa page<br />
                  • TOTP will now be activated successfully
                </p>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal-footer border-0"
              style={{
                position: "sticky",
                bottom: "0",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: "0 0 12px 12px",
                padding: "16px 32px 24px 32px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                style={{
                  borderColor: "#003092",
                  color: "#003092",
                  padding: "10px 28px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#003092";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#003092";
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>







    </>
  );

};

export default SignupWizard;
